<ul class="nav nav-tabs d-flex align-items-center" id="ExamReportEditTab" role="tablist">
  <li class="nav-item" role="presentation">
    <a
      class="nav-link exam-report-tab no-navigation active"
      id="ExamReport-tab"
      data-bs-toggle="tab"
      role="tab"
      aria-controls="ExamReport"
      aria-selected="true"
    >
      Jegyzőkönyv adatai
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a class="nav-link exam-report-tab no-navigation disabled"> Vizsgabiztosok </a>
  </li>
  <li class="nav-item" role="presentation">
    <a class="nav-link exam-report-tab no-navigation disabled"> Vizsgázók </a>
  </li>
  <li class="nav-item" role="presentation">
    <a class="nav-link exam-report-tab no-navigation disabled"> Eredmények </a>
  </li>
</ul>

<div class="tab-content" id="ExamReportEditTabContent">
  <div class="tab-pane fade active show" id="ExamReport" role="tabpanel" aria-labelledby="ExamReport-tab">
    <app-exam-report-form (onSubmitCallback)="onSubmit($event[0])"></app-exam-report-form>
  </div>
</div>
